import { useState } from "react";

export const useActivityLogList = data => {
  const [selectedActivityLog, setSelectedActivityLog] = useState(null);

  const config = {
    static_data: data,
    backend_querying: false,
    header: {
      title: "activity_log",
    },
    columns: [
      {
        db_field: "id",
        title: "title_id",
        type: "text",
        width: "10%",
      },
      {
        db_field: "user.name",
        title: "label_user",
        type: "text",
        width: "30%",
        formatter: (value, values) => value ?? values?.user?.name ?? "-",
      },
      {
        db_field: "created_at",
        title: "label_date",
        type: "date",
        width: "10%",
      },
      {
        db_field: "event",
        title: "type",
        type: "enum",
        width: "10%",
      },
      {
        db_field: "auditable_type",
        title: "model",
        type: "text",
        width: "35%",
        formatter: value => value ?? "-",
      },
      {
        type: "actions",
        width: "5%",
        actions: [
          {
            icon: "menu-report",
            type: "button",
            onClick: values => setSelectedActivityLog(values),
          },
        ],
      },
    ],
  };

  const handleCloseActivityLogDetails = () => setSelectedActivityLog(null);

  return { config, selectedActivityLog, handleCloseActivityLogDetails };
};
